/**
 * Object that holds auxiliary information. It can change the way the payment checkout and confirmation
 * pages operate.
 *
 * See bundles/payments/models/cart.js
 */

/**
 * @typedef {Object} AuxiliaryInfoItem
 * @param {string} options.typeName
 * @param {Object} options.definition
 * @param {boolean} options.providesContinueLink - This item specifies a continue link to send the user to
 */
class AuxiliaryInfoItem {
  constructor({ typeName, definition, providesContinueLink = false }: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'typeName' does not exist on type 'Auxili... Remove this comment to see the full error message
    this.typeName = typeName;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'definition' does not exist on type 'Auxi... Remove this comment to see the full error message
    this.definition = definition;

    // If this is true, then this.getContinueInfo() is expected to be truthy
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'providesContinueLink' does not exist on ... Remove this comment to see the full error message
    this.providesContinueLink = providesContinueLink;
  }

  getContinueInfo() {
    return undefined;
  }

  /**
   * Serialize to JSON to send to server
   */
  toJSON() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'definition' does not exist on type 'Auxi... Remove this comment to see the full error message
    const serializeDefinition = ['object', 'array', 'string', 'number'].indexOf(typeof this.definition) === -1;

    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'typeName' does not exist on type 'Auxili... Remove this comment to see the full error message
      typeName: this.typeName,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'definition' does not exist on type 'Auxi... Remove this comment to see the full error message
      definition: serializeDefinition ? this.definition.toJSON() : this.definition,
    };
  }
}

export default AuxiliaryInfoItem;
